module.exports = __webpack_public_path__ + "img/ea.eaf1e55aa.svg";